import * as tslib_1 from "tslib";
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var MapApi = /** @class */ (function () {
    function MapApi(api, loggingService) {
        this.api = api;
        this.loggingService = loggingService;
        this.mapProperties = 'id, extentJSON, name, uniqueName, description, data, isSystem, createdDate, lastEditedDate, isPublic, showOnAoi, basemap, categories{id, name}, layers{id, parentId, name}, mapCategories{id, name}, users{id, firstName, lastName}';
    }
    MapApi.prototype.deleteMap = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("mutation {\n            deleteMap(id: " + id + ")\n        }", null, 'GET', null)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.deleteMaps = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            mutation deleteMaps($ids: [Int]) {\n                deleteMaps(ids: $ids)\n            }\n        ", { ids: ids }, 'GET', 'deleteMaps')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.getMaps = function (id, properties) {
        if (properties === void 0) { properties = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = properties ? properties : this.mapProperties;
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query GetMaps($id: [Int]) {\n                maps(id: $id){\n                    " + props + "\n                }\n            }", { id: id }, 'GET', 'maps')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.getSystemMaps = function (applicationId, properties) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = properties ? properties : this.mapProperties;
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query {\n            applications(id: " + applicationId + ") {\n                maps(isSystem: true) {\n                    " + props + "\n                }\n            }\n        }", null, 'GET', 'applications')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.getUserMaps = function (id, properties) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetUserMaps($id: [Int]) {\n            users(id: $id) {\n                " + properties + "\n            }\n        }", { id: id }, 'GET', 'users')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.getUserMap = function (userId, mapId, applicationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var appIdFilter;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appIdFilter = '';
                        if (applicationId) {
                            appIdFilter = ", applicationId:" + applicationId;
                        }
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query GetUserMaps($userId: [Int], $mapId: [Int]) {\n            users(id: $userId) {\n                firstName, lastName, email, userMaps(mapId: $mapId" + appIdFilter + ") {\n                    map(isSystem: false) {\n                        id, name, description, data, isSystem, isPublic, createdDate, lastEditedDate, basemap, userMaps {\n                            userId, accessLevel }}}\n            }\n        }", { userId: userId, mapId: mapId }, 'GET', 'users')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.getUserMapsFolders = function (id, properties) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query getUserMapsFolders($id: [Int]) {\n                users(id: $id) {\n                    " + properties + "\n                }\n            }", { id: id }, 'GET', 'users')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.getMapSearch = function (searchText) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query MapSearch($searchText: [String]) {\n                    mapCatalog(search: $searchText){\n                        mapId\n                        primaryDisplayText\n                        secondaryDisplayText\n\n                    }\n            }", { searchText: searchText }, 'GET', 'mapCatalog')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.shareMap = function (userIds, mapId, emailSubject, emailBody) {
        if (emailSubject === void 0) { emailSubject = ''; }
        if (emailBody === void 0) { emailBody = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                mutation ShareMap($userIds: [Int], $mapId: Int, $emailSubject: String, $emailBody: String) {\n                    shareMap(userIds: $userIds, mapId: $mapId, emailSubject: $emailSubject, emailBody: $emailBody)\n                }\n        ", { userIds: userIds, mapId: mapId, emailSubject: emailSubject, emailBody: emailBody }, 'GET', 'shareMap')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.shareMaps = function (userIds, mapIds, emailSubject, emailBody) {
        if (emailSubject === void 0) { emailSubject = ''; }
        if (emailBody === void 0) { emailBody = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                mutation ShareMaps($userIds: [Int], $mapIds: [Int], $emailSubject: String, $emailBody: String) {\n                    shareMaps(userIds: $userIds, mapIds: $mapIds, emailSubject: $emailSubject, emailBody: $emailBody)\n                }\n        ", { userIds: userIds, mapIds: mapIds, emailSubject: emailSubject, emailBody: emailBody }, 'GET', 'shareMaps')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.unShareMap = function (userIds, mapId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                mutation unshareMap($userIds: [Int], $mapId: Int) {\n                    unshareMap(userIds: $userIds, mapId: $mapId)\n                }\n        ", { userIds: userIds, mapId: mapId }, 'GET', 'unshareMap')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.unShareMaps = function (userIds, mapIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                mutation unshareMaps($userIds: [Int], $mapIds: [Int]) {\n                    unshareMaps(userIds: $userIds, mapIds: $mapIds)\n                }\n        ", { userIds: userIds, mapIds: mapIds }, 'GET', 'unshareMaps')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.saveMap = function (map, layers, applicationId) {
        if (applicationId === void 0) { applicationId = 0; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!map.id) {
                            delete map.id;
                        }
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n            mutation SaveMap($map: MapInput!, $layers: [LayerInput!], $applicationId: Int){\n                saveMap(map: $map, layers: $layers, applicationId: $applicationId){\n                    " + this.mapProperties + "\n                }\n            }\n        ", { map: this.sanitize(map), layers: layers, applicationId: applicationId }, 'POST', 'saveMap')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.saveMapToUserFolder = function (mapId, folderId, oldFolderId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n          mutation SaveMapToUserFolder($mapId: Int, $folderId: Int, $oldFolderId: Int) {\n              saveMapToUserFolder(newUserFolderId: $folderId, mapId: $mapId, oldUserFolderId: $oldFolderId)\n          }\n        ", { mapId: mapId, folderId: folderId, oldFolderId: oldFolderId }, 'POST', 'saveMapToUserFolder')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapApi.prototype.copyMaps = function (mapIds, appId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = this.mapProperties;
                        return [4 /*yield*/, this.api.http2.graphqlRequest("\n            mutation CopyMaps($mapIds: [Int], $appId: Int) {\n                copyMaps(mapIds: $mapIds, appId: $appId){\n                    " + props + "\n                }\n            }\n        ", { mapIds: mapIds, appId: appId }, 'POST', 'copyMaps')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // async update(map) {
    //     return await this.api.http2.graphqlRequest(`
    //         mutation UpdateMap($map: MapInput!){
    //             saveMap(map: $map){
    //                 title
    //             }
    //         }
    //     `, { map: this.sanitize(map) }, 'POST', 'saveMap');
    // }
    MapApi.prototype.sanitize = function (map) {
        var result = this.api.pick(map, this.mapProperties.split(', '));
        return result;
    };
    MapApi.prototype.setTokenCookie = function (token, url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.api.setCookieInIFrame(token, url)];
            });
        });
    };
    MapApi.ngInjectableDef = i0.defineInjectable({ factory: function MapApi_Factory() { return new MapApi(i0.inject(i1.Api), i0.inject("LoggingService")); }, token: MapApi, providedIn: "root" });
    return MapApi;
}());
export { MapApi };
